import script from "./CourseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseForm.vue?vue&type=script&setup=true&lang=js"

import "./CourseForm.vue?vue&type=style&index=0&id=d59249c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d59249c0"]])

export default __exports__